function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M127.7 71l108.8-42.6-10.4-26.6L49.6 70.9v38.8L17.9 84.1 0 106.3l49.6 40.1v27l-31.7-25.6L0 170l49.6 40.1v59.2h219.6V71H127.7zm113 113.2H78.1V156h162.6v28.2zm0-56.7H78.1v-28h162.6v28zM78.1 240.8v-28.1h162.6v28.1H78.1z"
})));